export default __webpack_public_path__ + "static/media/under-development.4f8cd94a.png";